import { applianceType, reachable } from '~/helpers/fields-description';
import { LegrandModule } from './LegrandModule.model';

export class NLIB extends LegrandModule {
    get fieldReachable() {
        return reachable(this.reachable);
    }
    get fieldApplianceType() {
        return applianceType(this.appliance_type);
    }
}
